import React, { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Home, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import confetti from "canvas-confetti";

const SurveyThankYou = () => {
  useEffect(() => {
    // Fire confetti when component mounts
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min;
    }

    const interval: NodeJS.Timeout = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      
      // Since particles fall down, start a bit higher than random
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 250);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);


  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/30 py-12 pt-32">
      <div className="container mx-auto px-4 max-w-2xl">
        <Card className="shadow-xl text-center">
          <CardHeader className="space-y-6">
            <div className="flex justify-center">
              <CheckCircle className="h-16 w-16 text-green-500" />
            </div>
            <CardTitle className="text-4xl font-bold text-primary">
              Thank You!
            </CardTitle>
            <p className="text-xl text-muted-foreground">
              Your survey response has been successfully submitted
            </p>
          </CardHeader>

          <CardContent className="space-y-8">
            <div className="bg-muted/50 rounded-lg p-6">
              <p className="text-lg text-muted-foreground">
                Thank you for taking the time to participate in the SPO Member Consultation 
                on the Proposed Ware Crop Burn Down Compensation Scheme.
              </p>
              <p className="text-lg text-muted-foreground mt-4">
                The survey has now closed and is no longer accepting new responses.
              </p>
            </div>



          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SurveyThankYou;